namespace $.$$ {
	export class $bog_ainews_app extends $.$bog_ainews_app {}
}
